import { render, staticRenderFns } from "./MemberNoticeList.vue?vue&type=template&id=079f8302&"
import script from "./MemberNoticeList.vue?vue&type=script&lang=js&"
export * from "./MemberNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports